import { BREAKPOINTS, SETTINGS } from '../utils/constants';
import { throttle } from 'throttle-debounce';

const initAccordion = () => {
  const mobileOnlyAccordions = document.querySelectorAll('[data-mobile-accordion]');
  if (!mobileOnlyAccordions.length) return;

  /** Avoid closing open footer accordions on spurious mobile `resize` (URL bar, visual viewport). */
  let previousWasDesktop = null;

  const syncAccordionsToViewport = () => {
    const isDesktop = window.innerWidth >= BREAKPOINTS.DESKTOP;

    if (isDesktop) {
      mobileOnlyAccordions.forEach(accordion => {
        accordion.open = true;
      });
    } else {
      const shouldResetClosed =
        previousWasDesktop === true || previousWasDesktop === null;
      if (shouldResetClosed) {
        mobileOnlyAccordions.forEach(accordion => {
          accordion.open = false;
        });
      }
    }

    previousWasDesktop = isDesktop;
  };

  syncAccordionsToViewport();
  window.addEventListener('resize', throttle(SETTINGS.THROTTLE_DELAY, syncAccordionsToViewport));
};

export default initAccordion;
